/*
 * @Author: lijinyang
 * @FilePath: /mall-fe/src/libs/enums.ts
 * @Description: 商城首页相关枚举信息
 *
 */
// 用户审批状态
export enum UserAuthEnum {
  NO_AUDIT = 0, // 不需要审批
  AUDITING, // 审批中
  FAIL, // 审批未通过
  PASS, // 审批通过
  CANCEL, // 审批撤销
  AUTHENTICATION, // 待认证
}

// 组织角色类型
export enum OrgRoleType {
  ZhiCai = 1, // 直采
}

// 用户认证状态
export enum USER_AUTHRIZED_STATUS {
  AUDIT_NONE = 0, //  未认证
  AUDIT_SUPPLIER, // 已认证供应商
  AUDIT_PURCHASE, // 已认证采购商
  AUDIT_BOTH, // 已认证供应商、已认证采购商
}

// a标签target
export enum HREF_TARGET_TYPE {
  TOP = 0, // _top
  BLANK, // _blank
}

// 门户导航模块
export enum PORTAL_NAV_MODULE {
  HOME = 1,
  TENDER_HALL = 2,
  GROUP_BUY = 3,
  MALL = 4,
  FINANCIAL = 5,
  CUSTOM = 100,
}

// 门户导航配置类型
export enum PORTAL_SETTING_TYPE {
  AUTO = 0, // 默认
  MANUAL, // 自定义
}

// 顶部搜索框搜索类型
export const SearchTypeEnum = {
  GOODS: {
    value: 0,
    label: '搜商品',
    placeholder: '请输入商品编号、商品名称、分类属性、品牌型号、推广标题',
  },
  STORE: {
    value: 1,
    label: '搜店铺',
    placeholder: '请输入店铺名称、供应商名称',
  },
  // BUSINESS: {
  //   value: 2,
  //   label: '搜商机',
  //   placeholder: '请输入商机名称、编号、采购企业名称',
  // },
  // HOUSE: {
  //   value: 3,
  //   label: '搜房源',
  //   placeholder: '请输入房源名称、发布机构名称搜索',
  // },
};

// 搜索框类型 待删除
export const NewSearchTypeEnum = {
  GOODS: {
    value: 0,
    label: '商品',
    placeholder: '请输入商品编号、商品名称、分类属性、品牌型号、推广标题',
  },
  STORE: {
    value: 1,
    label: '店铺',
    placeholder: '请输入店铺名称、供应商名称',
  },
  // BUSINESS: {
  //   value: 2,
  //   label: '商机',
  //   placeholder: '请输入商机名称、编号、采购企业名称',
  // },
};

// 身份类型
export enum IndentityType {
  SUPPLIER = 1, // 供应
  PURCHASER = 2, // 采购
}

// 会员升级
export enum BUSINESS_TYPE {
  INQUIRY = 0,
  GROUP_BUY,
  BIDING,
}

export enum BANNER_TYPE_ENUM {
  ZJ3_MALL_INDEX = 91, // 首页
  ZJ3_JI_CAI = 92, // 大集采专区
  ZJ3_PING_PAI = 93, // 品牌专区
  ZJ3_ZHI_GONG = 94, // 厂商直供 = 三局严选
  ZJ3_ZI_YIN = 101, // 自营专区
  ZJ3_ZI_YIN_H5 = 102, // 自营专区 H5
  ZJ3_FU_LI = 112, // 福利专区
  ZJ3_FU_LI_H5 = 113, // 福利专区(移动端) H5
  ZJ3_MALL_INDEX_MOBILE = 95, // 首页(移动端)
  ZJ3_JI_CAI_MOBILE = 96, // 大集采专区(移动端)
  ZJ3_PING_PAI_MOBILE = 97, // 品牌专区(移动端)
  ZJ3_ZHI_GONG_MOBILE = 98, // 厂商直供(移动端)
  ZJ3_CONCRETE = 100, // 混凝土
  ZJ3_CONCRETE_MOBILE = 99, // '混凝土专区(移动端)'
  ZJ31_EGO = 105, // 易购专区
  ZJ3_HIRE_BANNER = 110, // 招租广告位
  ZJ3_HIRE_BANNER_H5 = 111, // 招租广告位(移动端) H5
  ZJ3_NEW_HOME_BANNER = 114, // 对外商城新首页banner
  ZJ3_DFZQ = 115, // 抵房专区
  ZJ3_OUTWARD_HIRE_BANNER = 116, // 对外商城首页招租广告位
  ZJ3_WLZQ = 117, // 物流专区
  ZJ3_GREEN_ZONE = 118, // 绿色专区
}

// 首页楼层类型
export enum FloorType {
  Index = 1, // 内部采购专用 首页推荐商品
  IndexBrands = 2,
  Djczq = 3,
  Brands = 4,
  Sjyx = 7,
  IndexBrandsMobile = 8,
  Concrete = 10,
  ZJ3_ZY = 11,
  ZJ3_HOT_SALE_SKU = 12, // 内部采购专用 首页热销商品
  ZJ3_RECOMMEND_SHOP = 13, // 内部采购专用 首页推荐店铺
  ZJ3_EGO = 14,
  ZJ3_HOT_SALE_SKU_NEW = 23, // 对外首页热销商品
  ZJ3_WELFARE = 24,
  ENTERPRISE_WISE_SELECTION_NEW = 25, //  对外首页楼层类目
  ZJ3_RECOMMEND_SHOP_NEW = 26, // 对外首页智能推荐
  ZJ3_ZY_H5 = 28, // 企业版移动端自营专区
}

// 用户身份
export enum UserIdentity {
  Purchaser = '50',
  Supplier = '51',
  Operator = '52',
}

export const UserTypeText = {
  [UserIdentity.Purchaser]: '采购商',
  [UserIdentity.Supplier]: '供应商',
  [UserIdentity.Operator]: '运营',
};

// 认证状态
export enum UserAuditStatus {
  NONE = -1, // 未认证
  AUDIT = 0, // 审核中
  AGREE = 10, // 审核通过
  REJECT = 20, // 审核拒绝
}

// 会员状态
export enum MemBerStatus {
  NON_MEMBER, // 非会员
  EFFECTIVE_MEMBER, // 生效中
  EXPIRED_MEMBER, // 已过期
  PROBATION_MEMBER, // 体验期的会员
  EXPIRED_PROBATION_MEMBER, // 验过期
}

export enum CartTypeEnum {
  SELF = 1, // 自营商品
  SHOP, // 店铺商品
}

// 订单发货单物流状态
export const OrderTradeDeliveryLogisticsStatusEnum = {
  DELIVERY: {
    value: 10,
    label: '已发货',
    icon: 'paut-yifahuo',
  },
  TRANSPORT_START: {
    value: 15,
    label: '运输中',
    icon: 'paut-yunshuzhong',
  },
  TRANSPORT: {
    value: 20,
    label: '运输中',
    icon: 'paut-yunshuzhong',
  },
  DELIVERD: {
    value: 25,
    label: '已送达',
    icon: 'paut-yunshuzhong',
  },
  RECEIVING: {
    value: 30,
    label: '收货中',
    icon: 'paut-shouhuozhong',
  },
  RECEIVED: {
    value: 40,
    label: '已收货',
    icon: 'paut-shouhuowancheng',
  },
};

// 订单审批状态
export const TenderTradeOrderAuditStatusEnum = {
  ALL: {
    value: '',
    label: '全部',
    cls: '',
  },
  PROCESSING_NONE: {
    value: 0,
    label: '',
    color: '#656569',
    cls: '',
  },
  PROCESSING: {
    value: 1,
    label: '审批中',
    color: '#5476FF',
    cls: 'audit-processing',
  },
  PROCESSING_FAILURE: {
    value: 2,
    label: '审批拒绝',
    color: '#FFB500',
    cls: 'audit-process-failure',
  },
  PROCESSING_SUCCESS: {
    value: 3,
    label: '审批通过',
    color: '#656569',
    cls: 'audit-process-success',
  },
  PROCESSING_REGRESSION: {
    value: 4,
    label: '审批撤销',
    color: '#FFB500',
    cls: 'audit-process-regression',
  },
};

// 发票类型
export const OrderTradeInvoiceTypeEnum = {
  VAT_INVOICE: {
    value: 0,
    label: '增值税普通发票',
    cls: '',
  },
  VAT_SPECIAL_INVOICE: {
    value: 1,
    label: '增值税专用发票',
    cls: '',
  },
};

// 订单类型
export const OrderTradeTypeEnum = {
  CONTRACT: {
    value: 1,
    label: '合同下单',
    cls: '',
    displayLabel: '合同订单',
  },
  MATCH: {
    value: 2,
    label: '撮合下单',
    cls: '',
    displayLabel: '撮合订单',
  },
  INQUIRY: {
    value: 3,
    label: '询价单下单',
    cls: '',
    displayLabel: '询价订单',
  },
  COMPETITION: {
    value: 4,
    label: '竞价单下单',
    cls: '',
    displayLabel: '竞价订单',
  },
};

// 订单交易方式
export const OrderPaymentPeriodTypeEnum = {
  HAS_PAYMENT_DAYS: {
    value: 0,
    label: '结算付款',
    cls: '',
  },
  PAY_BEFORE_DELIVERY: {
    value: 1,
    label: '先款后货',
    cls: '',
  },
  CASH_ON_DELIVERY: {
    value: 2,
    label: '货到付款',
    cls: '',
  },
  PRE_PAY: {
    value: 3,
    label: '预付款',
    cls: '',
  },
};

// 订单支付状态
export const OrderPaymentStatusEnum = {
  NO_NEED_PAY: {
    value: 0,
    label: '无需支付',
  },
  WAITING_PAY: {
    value: 5,
    label: '待支付',
  },
  PART_PAID: {
    value: 8,
    label: '部分支付',
  },
  PAID: {
    value: 10,
    label: '已支付',
  },
};

// 支付方式
export const PaymentTypeEnum = {
  FINANCING: {
    value: 1,
    label: '融资',
  },
  CASH: {
    value: 2,
    label: '现金',
  },
  SELF_OPERATED: {
    value: 4,
    label: '自营',
  },
};

// 订单状态
export const TenderTradeOrderStatusEnum = {
  ALL: {
    value: '',
    label: '全部',
    cls: '',
  },
  BOOKING: {
    value: 10,
    label: '编制中',
    cls: 'order-book',
    color: '#656569',
  },
  WAIT_SUPPLIER_CONFIRM: {
    value: 15,
    label: '待确认',
    cls: 'order-wait-confirm',
    color: '#5476FF',
  },
  BOOKING_FOR_SHIPING: {
    value: 20,
    label: '待发货',
    cls: 'order-ship',
    color: '#5476FF',
  },
  BOOKING_DENIED: {
    value: 30,
    label: '已拒绝',
    cls: 'order-deny',
    color: '#FE3351',
  },
  BOOKING_SHIPING_DONE: {
    value: 40,
    label: '已发货',
    cls: 'order-ship-done',
    color: '#5476FF',
  },
  BOOKING_RECEIVING: {
    value: 45,
    label: '收货中',
    cls: 'order-ship-receiving',
    color: '#5476FF',
  },
  BOOKING_FINISHED: {
    value: 50,
    label: '交易成功',
    cls: 'order-finish',
    color: '#00BF83',
  },
  BOOKING_CANCELLED: {
    value: 60,
    label: '已取消',
    cls: 'order-cancel',
    color: '#656569',
  },
};

// 自合同订单状态
export const SubcontractTradeOrderStatusEnum = {
  ALL: {
    value: '',
    label: '全部',
    cls: '',
  },
  BOOKING: {
    value: 10,
    label: '编制中',
    cls: 'order-book',
    color: '#656569',
  },
  WAIT_SUPPLIER_CONFIRM: {
    value: 15,
    label: '待确认',
    cls: 'order-wait-confirm',
    color: '#FFB500',
  },
  BOOKING_FOR_SHIPING: {
    value: 20,
    label: '待结算',
    cls: 'order-ship',
    color: '#5476FF',
  },
  BOOKING_DENIED: {
    value: 30,
    label: '已拒绝',
    cls: 'order-deny',
    color: '#FE3351',
  },
  BOOKING_SHIPING_DONE: {
    value: 40,
    label: '已发货',
    cls: 'order-ship-done',
    color: '#5476FF',
  },
  BOOKING_RECEIVING: {
    value: 45,
    label: '结算中',
    cls: 'order-ship-receiving',
    color: '#5476FF',
  },
  BOOKING_FINISHED: {
    value: 50,
    label: '交易成功',
    cls: 'order-finish',
    color: '#00BF83',
  },
  BOOKING_CANCELLED: {
    value: 60,
    label: '已取消',
    cls: 'order-cancel',
    color: '#656569',
  },
};

// 发货状态
export namespace DeliverStatus {
  export enum deliverStatus {
    WAIT_CONFIRM = 2, // 待确认
    WAIT_OUTBOUND = 5, // 待出库
    DAI_SHOU_HUO = 10, // 待收货 WILL_RECEIVE
    SHOU_HUO_ZHONG = 15, // 收货中 RECEIVE_ING
    YI_SHOU_HUO = 20, // 已收货 RECEIVED
    YI_TUI_HUO = 40, // RETURNED
    YI_ZUO_FEI = 50, // INVALID
  }

  export const statusEnum = {
    [deliverStatus.WAIT_CONFIRM]: {
      text: '待确认',
      color: 'var(--primaryColor)',
    },
    [deliverStatus.WAIT_OUTBOUND]: {
      text: '待出库',
      color: 'var(--primaryColor)',
    },
    [deliverStatus.DAI_SHOU_HUO]: {
      text: '待收货',
      color: 'var(--primaryColor)',
    },
    [deliverStatus.SHOU_HUO_ZHONG]: {
      text: '收货中',
      color: 'var(--primaryColor)',
    },
    [deliverStatus.YI_SHOU_HUO]: {
      text: '已收货',
      color: '#3CBD30',
    },
    [deliverStatus.YI_TUI_HUO]: {
      text: '已退货',
      color: '#F24804',
    },
    [deliverStatus.YI_ZUO_FEI]: {
      text: '已作废',
      color: '#F24804',
    },
  };

  // 订单状态
  export const TenderTradeOrderStatusEnum = {
    ALL: {
      value: '',
      label: '全部',
      cls: '',
    },
    BOOKING: {
      value: 10,
      label: '编制中',
      cls: 'order-book',
      color: '#656569',
    },
    BOOKING_FOR_SHIPING: {
      value: 20,
      label: '待发货',
      cls: 'order-ship',
      color: '#5476FF',
    },
    BOOKING_DENIED: {
      value: 30,
      label: '已拒绝',
      cls: 'order-deny',
      color: '#FE3351',
    },
    BOOKING_SHIPING_DONE: {
      value: 40,
      label: '已发货',
      cls: 'order-ship-done',
      color: '#5476FF',
    },
    BOOKING_FINISHED: {
      value: 50,
      label: '交易成功',
      cls: 'order-finish',
      color: '#00BF83',
    },
    BOOKING_CANCELLED: {
      value: 60,
      label: '已取消',
      cls: 'order-cancel',
      color: '#656569',
    },
  };

  // 交易方式类型
  export const OrderPaymentPeriodTypeEnum = {
    HAS_PAYMENT_DAYS: {
      value: 0,
      label: '账期',
      cls: '',
    },
    PAY_BEFORE_DELIVERY: {
      value: 1,
      label: '先款后货',
      cls: '',
    },
    CASH_ON_DELIVERY: {
      value: 2,
      label: '货到付款',
      cls: '',
    },
    PRE_PAY: {
      value: 3,
      label: '预付款',
      cls: '',
    },
  };
}

// 订单流程按钮展示类型
export enum BtnVisibleTypeEnum {
  PURCHASER_TRADE_LIST = 0, // 采购商订单列表
  PURCHASER_TRADE_LIST_DELETE = 1, // 采购商订单删除按钮
  PURCHASER_TRADE_LIST_FINISH_ORDER = 2, // 采购商订单列表完成订单
  PURCHASER_TRADE_LIST_CASH_PAY = 3, // 采购商订单列表现金支付
  PURCHASER_TRADE_LIST_FINANCING_PAY = 4, // 采购商订单列表融资申请
  PURCHASER_TRADE_LIST_RE_ORDER = 5, // 采购商订单列表再次购买
  PURCHASER_TRADE_LIST_VIEW_RELATION_DELIVERY = 6, // 采购商订单列表查看关联发货单
  PURCHASER_TRADE_WAIT_FOR_CONFIRM_CONTRACT_SUBMIT = 7, // 采购商订单编制中合同提交订单按钮
  PURCHASER_TRADE_WAIT_FOR_CONFIRM_MALL_SUBMIT = 8, // 采购商订单编制中合同提交订单按钮
  PURCHASER_TRADE_WAIT_FOR_CONFIRM_CONTRACT_AUDIT_CANCEL = 9, // 采购商订单编制中合同订单撤销审批
  PURCHASER_TRADE_WAIT_FOR_CONFIRM_MALL_AUDIT_CANCEL = 10, // 采购商订单编制中商城订单撤销审批
  PURCHASER_TRADE_WAIT_FOR_CONFIRM_VIEW_AUDIT_INFO = 11, // 采购商订单编制中查看审批记录审批
  PURCHASER_TRADE_WAIT_FOR_CONFIRM_DETAIL_RE_ORDER = 12, // 采购商订单编制明细中再次购买
  PURCHASER_TRADE_DETAIL_WAITING_PAY_CANCEL = 13, // 采购商订单待支付取消订单
  SUPPLIER_TRADE_DETAIL_REFUSE = 14, // 供应商待发货订单拒绝
  SUPPLIER_TRADE_DETAIL_SHIP_ORDER = 15, // 供应商待发货订单发货
  PURCHASER_TRADE_LIST_MORE_DELETE = 16, // 采购商订单列表更多-删除
  PURCHASER_TRADE_LIST_MORE_AGAIN_BUY = 17, // 采购商订单列表更多-再次购买
  PURCHASER_TRADE_LIST_MORE_CANAL_ORDER = 18, // 采购商订单列表更多-取消订单
  PURCHASER_TRADE_LIST_MORE_SHOW_RELATION_DELIVER = 19, // 采购商订单列表更多-查看关联发货单
  PURCHASER_DELIVERY_LIST_DELETE = 20, // 采购商送货管理删除
  PURCHASER_DELIVERY_LIST_LOGISTICS = 21, // 采购商送货管理物流跟踪
  PURCHASER_DELIVERY_DETAIL_AGAIN = 22, // 采购商送货管理明细再次收货
  PURCHASER_DELIVERY_DETAIL_CONFIRM = 23, // 采购商送货管理明细确认收货
  PURCHASER_DELIVERY_DETAIL_END_RECEIVING = 24, // 采购商送货管理明细结束
  PURCHASER_DELIVERY_RECEIVING_APPLY_RETURN = 25, // 采购商收货管理申请退货
  PURCHASER_TRADE_RETURN_REVOKE = 26, // 采购商退货管理撤销申请
  PURCHASER_TRADE_RETURN_VIEW = 27, // 采购商退货管理查看
  PURCHASER_TRADE_RETURN_DETAIL_REVOKE = 28, // 采购商退货明细撤销申请,
  PURCHASER_TRADE_RETURN_DETAIL_APPLY_RETURN = 29, // 采购商退货明细申请退货
  PURCHASER_DELIVERY_RECEIVING_APPLY_TO_COMPLETE = 30, // 采购商收货管理立即完善
  PURCHASER_DELIVERY_RECEIVING_APPLY_UPDATE = 31, // 采购商收货管理修改收货信息
  PURCHASER_DELIVERY_RECEIVING_APPLY_DELETE = 32, // 采购商收货管理删除
  PURCHASER_DELIVERY_RECEIVING_APPLY_VOID = 33, // 采购商收货管理作废
}

// 退货状态
export namespace ReturnStatus {
  export const ReturnStatusEnum = {
    WILL_CONFIRM: {
      value: 10,
      label: '退货中',
    },
    CONFIRMED: {
      value: 20,
      label: '已退货',
    },
    CANCELED: {
      value: 30,
      label: '已撤回',
    },
    REFUSE: {
      value: 40,
      label: '已拒绝',
    },
    INVALID: {
      value: 50,
      label: '已作废',
    },
  };
}

// 订单类型
export const TenderTradeOrderTypeEnum = {
  MATCH_ORDER: {
    value: 2,
    label: '电商订单',
  },
  CONTRACT_ORDER: {
    value: 1,
    label: '传统订单',
  },
  // INQUIRY_ORDER: {
  //   value: 3,
  //   label: '询价订单',
  // },
  COMPETITION_ORDER: {
    value: 4,
    label: '竞价订单',
  },
};

// 组织查询范围
export const OPTIONAL_SCOPE_KEYS = {
  UPPER_LEVEL_ORGANIZATION: 'upper_level_organization', // 本上级
  LOWER_LEVEL_ORGANIZATION: 'lower_level_organization', // 本下级
  THIS_LEVEL_ORGANIZATION: 'this_level_organization', // 本级
  ROLE: 'role', // 按角色
  ASSIGN_USER: 'assign_user', // 指定用户
  WHOLE_COMPANY: 'whole_company',
  ROLE_TAG: 'role_tag',
};

// 钢筋专区属性数据类型
export enum MmuDataType {
  TEXT = 1, // 文本
  FLOAT, // 浮点
  INT, // 整数
}

// 钢筋专区属性选择类型
export enum MmuModeType {
  RADIO = 1, // 单选
  CHECKBOX, // 多选
}

// 网价来源
export enum NetPriceSourceEnum {
  INFO = 1, // 信息价
  LANGE, // 兰格网网价
  WDGTW, // 钢铁网网价
  BASE, // 基础价
  SHYSJSW, // 上海有色金属网
  BASE_PRICE, // "固定协议价"
}

// 交易规则类型
export enum AgreementType {
  beCurrent, // 外部
  internal, // 内部
}

// 交易协议缺失原因
export enum AgreementPriceMissingReason {
  TRADE_AGREEMENT_PRICE_MISSING = 3, // 无协议价
}

// TODO 这个枚举和上面枚举重复了
// Renovation功能中将使用NetPriceSourceEnumForOrder枚举的地方改为了使用NetPriceSourceEnum枚举
// 等Renovation功能开关清掉后需要移除这个枚举
export enum NetPriceSourceEnumForOrder {
  INFO = 1,
  NETWORK_LG,
  NETWORK_GT,
  CUSTOMIZE,
  SHYSJSW, // 上海有色金属网
}

// 网价类型
export enum NetPriceSourceFormEnum {
  INFO = 1, // 信息价
  NET, // 网价
  BASE, // 基础价
}

// 报价类型
export enum QuoteMode {
  WITHOUT_TAX_TYPE = 1, // 不含税
  WITH_TAX_TYPE, // 含税
}

// 审批流水节点类型
export enum StreamNodeType {
  /**
   * 审批流水中的 审批节点
   */
  AUDIT = 'audit',

  /**
   * 审批流水中的 抄送节点
   */
  CC = 'cc',

  /**
   * 审批流水中的 并行节点，通常在发起流程时使用
   */
  PARALLEL = 'parallel',

  /**
   * 正在审批的流程中，当前所处的流水的节点。在"当前节点中"审批人可能会有多个，同时待审批的"流程节点"也可能会有多个
   */
  PRESENT = 'present',

  /**
   * 审批流水节点中的开始节点
   */
  START = 'start',

  /**
   * 开始节点，但此时的开始节点会处理任务（通常出现在回退到开始节点、条件指向开始节点等场景）
   */
  START_FOR_AUDIT = 'start_for_audit',

  /**
   * 审批流水节点中的结束节点
   */
  END = 'end',

  /**
   * 审批流水 中的 转派节点
   */
  TRANSFER = 'transfer',

  /**
   * 审批流水 中的 撤销节点
   */
  CANCEL = 'cancel',

  /**
   * 审批流水 中的 加签节点
   */
  ADD_SIGN = 'add_sign',
}

// 结算交易方式类型
export const BillingPeriodEnum = {
  DAY_0: {
    value: 0,
    label: '结算付款（立即付款）',
  },
  DAY_7: {
    value: 1,
    label: '结算付款（7天后一次性付款）',
  },
  MONTH_1: {
    value: 2,
    label: '结算付款（1个月后一次性付款）',
  },
  MONTH_2: {
    value: 5,
    label: '结算付款（2个月后一次性付款）',
  },
  MONTH_3: {
    value: 3,
    label: '结算付款（3个月后一次性付款）',
  },
  MONTH_4: {
    value: 8,
    label: '结算付款（4个月后一次性付款）',
  },
  MONTH_5: {
    value: 9,
    label: '结算付款（5个月后一次性付款）',
  },
  MONTH_6: {
    value: 4,
    label: '结算付款（6个月后一次性付款）',
  },
  OTHER: {
    value: 6,
    label: '结算付款（其他账期）',
  },
  INSTALLMENT: {
    value: 7,
    label: '结算付款（分期付款）',
  },
};

// 融资交易类型
export const AccountPeriodEnum = {
  BEFORE_PAYMENT: {
    value: 2,
    label: '先款后货',
  },
  AFTER_PAYMENT: {
    value: 1,
    label: '货到付款',
  },
  PRE_PAYMENT: {
    value: 3,
    label: '预付款',
  },
  CUSTOM: {
    value: 0,
    label: '结算付款',
  },
};

// 订单的发货收获状态
export const OrderTradeDeliveryReceivingStatusEnum = {
  TO_COMPLETE: {
    value: 0,
    label: '待完善',
    color: '#656569',
  },
  PREPARATION: {
    value: 2,
    label: '编制中',
    color: '#656569',
  },
  DRAFT: {
    value: 5,
    label: '已提交',
    color: '#656569',
  },
  TO_SETTLE: {
    value: 10,
    label: '已收货',
    color: '#5476FF',
  },
  SETTLED: {
    value: 20,
    label: '已结算',
    color: '#00BF83',
  },
  REFUND: {
    value: 30,
    label: '已退货',
    color: '#FE3351',
  },
  INVALID: {
    value: 100,
    label: '已作废',
    color: '#656569',
  },
};

// 订单的发货收货确认状态
export const OrderTradeDeliveryReceivingConfirmStatusEnum = {
  WAIT_CONFIRM: { value: 0, label: '待确认' },
  AGREE: { value: 10, label: '同意' },
  DISAGREE: { value: 20, label: '不同意' },
};

// 订单的发货收货方式
export const OrderTradeDeliveryReceivingWayEnum = {
  CHECK_NUM: {
    value: 0,
    label: '点验计数',
  },
  WEIGHT: {
    value: 1,
    label: '地磅称重',
  },
};

// 采购商收货状态
export const PurchaserReceivingStatusEnum = {
  TO_COMPLETE: {
    value: 0,
    label: '待完善',
    color: 'var(--primaryColor)',
  },
  PREPARATION: {
    value: 2,
    label: '编制中',
    color: '#666',
  },
  DRAFT: {
    value: 5,
    label: '已提交',
    color: '#656569',
  },
  TO_SETTLE: {
    value: 10,
    label: '已收货',
    color: '#3CBD30',
  },
  WAIT_CONFIRM: {
    value: 14,
    label: '待确认',
    color: '#3CBD30',
  },
  FINNISH: {
    value: 15,
    label: '已完成',
    color: '#3CBD30',
  },
  REFUSE: {
    value: 16,
    label: '已拒绝',
    color: '#3CBD30',
  },
  SETTLED: {
    value: 20,
    label: '已结算',
    color: '#3CBD30',
  },
  RETURN: {
    value: 30,
    label: '已退货',
    color: '#666',
  },
  INVALID: {
    value: 100,
    label: '已作废',
    color: '#666',
  },
};

// 采购商收货确认状态
export const PurchaserReceivingConfirmStatusEnum = {
  NO_CONFIRM: {
    value: null,
    label: '无需供方确认',
    color: '#656569',
  },
  DRAFT: {
    value: 0,
    label: '待确认',
    color: '#656569',
  },
  AGREE: {
    value: 10,
    label: '同意',
    color: '#3CBD30',
  },
  REJECT: {
    value: 20,
    label: '拒绝',
    color: '#FE3351',
  },
};

// 收货单的审批状态
export const ReceivingAuditStatusEnum = {
  AUDITING: {
    value: 1,
    label: '审批中',
    color: '#5476FF',
  },
  FAIL: {
    value: 2,
    label: '审批拒绝',
    color: '#FE3351',
  },
  PASS: {
    value: 3,
    label: '审批通过',
    color: '#00BF83',
  },
  CANCEL: {
    value: 4,
    label: '审批撤销',
    color: '#656569',
  },
};

export const OrderTradeTypeEnumV2 = {
  CONTRACT: {
    value: 1,
    label: '传统订单',
  },
  MATCH: {
    value: 2,
    label: '电商订单',
  },
  COMPETITION: {
    value: 4,
    label: '竞价订单',
  },
};

export const OrderApproachModeEnum = {
  SELF_SOURCING: {
    value: 2,
    label: '自采',
  },
  A_SURNAME: {
    value: 1,
    label: '甲供',
  },
};

// 订单列表用这个枚举
export const Order2ApproachModeEnum = {
  SELF_SOURCING: {
    value: 1,
    label: '自采',
  },
  A_SURNAME: {
    value: 2,
    label: '甲供',
  },
};

export const OrderPurchaseTypeEnum = {
  COMMON: {
    value: 1,
    label: '普通',
  },
  REBAR: {
    value: 2,
    label: '钢筋',
  },
  CONCRETE: {
    value: 3,
    label: '混凝土',
  },
};

// 发货
export const OrderTradeTransactionTypeEnum = {
  SKU: {
    value: 1,
    label: '采购',
  },
  PROFESSIONAL_SUBCONTRACT: {
    value: 2,
    label: '分包',
  },
  LEASE: {
    value: 5,
    label: '租赁',
  },
};

// 订单
export const OrderTransactionTypeEnum = {
  SKU: {
    value: 1,
    label: '采购',
  },
  PROFESSIONAL_SUBCONTRACT: {
    value: 3,
    label: '分包',
  },
  LEASE: {
    value: 2,
    label: '租赁',
  },
};

export const TransactionPurchaseTypeEnum = {
  PRODUCTION_METERIALS: {
    value: 1,
    label: '生产物资',
  },
  NOT_PRODUCTION_METERIALS: {
    value: 2,
    label: '非生产物资',
  },
};

// 收货单审批状态简写名称
export const ReceivingAuditStatusShortNameEnum = {
  AUDITING: {
    value: 1,
    label: '审批中',
    color: '#5476FF',
  },
  FAIL: {
    value: 2,
    label: '审批拒绝',
    color: '#FE3351',
  },
  PASS: {
    value: 3,
    label: '审批通过',
    color: '#00BF83',
  },
  CANCEL: {
    value: 4,
    label: '审批撤销',
    color: '#656569',
  },
};

// 发货单的审批状态
export const DeliverAuditStatusEnum = {
  AUDITING: {
    value: 1,
    label: '审批中',
    color: '#5476FF',
  },
  FAIL: {
    value: 2,
    label: '审批拒绝',
    color: '#FE3351',
  },
  PASS: {
    value: 3,
    label: '审批通过',
    color: '#00BF83',
  },
  CANCEL: {
    value: 4,
    label: '审批撤销',
    color: '#656569',
  },
};

// 发货单审批状态简写
export const DeliverAuditStatusShortNameEnum = {
  AUDITING: {
    value: 1,
    label: '审批中',
    color: '#5476FF',
  },
  FAIL: {
    value: 2,
    label: '审批拒绝',
    color: '#FE3351',
  },
  PASS: {
    value: 3,
    label: '审批通过',
    color: '#00BF83',
  },
  CANCEL: {
    value: 4,
    label: '审批撤销',
    color: '#656569',
  },
};

// 订单的发货收货供应商确认状态
export const OrderTradeDeliveryReceivingSupplierConfirmStatusEnum = {
  WAIT_CONFIRM: {
    value: 0,
    label: '待确认',
    text: '待供方确认',
    cls: '',
    color: '#656569',
  },
  AGREE: {
    value: 10,
    label: '同意',
    text: '供方同意',
    cls: '',
    color: '#3CBD30',
  },
  DISAGREE: {
    value: 20,
    label: '拒绝',
    text: '供方拒绝',
    cls: '',
    color: '#FE3351',
  },
  NOT_NEED_CONFIRM: {
    value: 30,
    label: '无需确认',
    text: '无需确认',
    cls: '',
    color: '#656569',
  },
};

// 发货管理列表使用
export const DeliveryConfirmStatusEnum = {
  WAIT_CONFIRM: {
    value: 0,
    label: '待确认',
    text: '待供方确认',
    cls: '',
  },
  AGREE: {
    value: 10,
    label: '同意',
    text: '供方同意',
    cls: '',
  },
  DISAGREE: {
    value: 20,
    label: '拒绝',
    text: '供方拒绝',
    cls: '',
  },
  NO_CONFIRM: {
    value: 30,
    label: '无需确认',
    text: '供方无需确认',
    cls: '',
  },
};

// 供应商订单状态
export const supplierOrderStatusEnum = {
  BOOKING: {
    value: 10,
    label: '编制中',
  },
  WAIT_SUPPLIER_CONFIRM: {
    value: 15,
    label: '待确认',
  },
  BOOKING_FOR_SHIPING: {
    value: 20,
    label: '待发货',
  },
  BOOKING_DENIED: {
    value: 30,
    label: '已拒绝',
  },
  BOOKING_SHIPING_DONE: {
    value: 40,
    label: '已发货',
  },
  BOOKING_RECEIVING: {
    value: 45,
    label: '收货中',
  },
  BOOKING_FINISHED: {
    value: 50,
    label: '交易成功',
  },
  BOOKING_CANCELLED: {
    value: 60,
    label: '已取消',
  },
};

// 发货状态
export const DeliveryStatusEnum = {
  WAIT_CONFIRM: {
    value: 2,
    label: '待确认',
    color: '#656569',
  },
  WAIT_OUTBOUND: {
    value: 5,
    label: '待出库',
    color: '#656569',
  },
  WILL_RECEIVE: {
    value: 10,
    label: '待收货',
    color: '#FFB500',
  },
  RECEIVE_ING: {
    value: 15,
    label: '收货中',
    color: '#5476FF',
  },
  RECEIVED: {
    value: 20,
    label: '已收货',
    color: '#00BF83',
  },
  INVALID: {
    value: 50,
    label: '已作废',
    color: '#656569',
  },
};

// 采购商订单状态
export const purchaserOrderStatusEnum = {
  BOOKING: {
    value: 10,
    label: '编制中',
  },
  WAIT_SUPPLIER_CONFIRM: {
    value: 15,
    label: '待确认',
  },
  BOOKING_FOR_SHIPING: {
    value: 20,
    label: '待发货',
  },
  BOOKING_DENIED: {
    value: 30,
    label: '已拒绝',
  },
  BOOKING_SHIPING_DONE: {
    value: 40,
    label: '已发货',
  },
  BOOKING_RECEIVING: {
    value: 45,
    label: '收货中',
  },
  BOOKING_FINISHED: {
    value: 50,
    label: '交易成功',
  },
  BOOKING_CANCELLED: {
    value: 60,
    label: '已取消',
  },

  // SETTLEMENET: {
  //   value: "waitSettlement",
  //   label: "结算中",
  //   cls: "order-ship-receiving",
  //   color: "#656569",
  // },
};

// 采购商订单状态
export const purchaserTransactionOrderStatusEnum = {
  BOOKING: {
    value: 10,
    label: '编制中',
  },
  WAIT_SUPPLIER_CONFIRM: {
    value: 15,
    label: '待确认',
  },
  BOOKING_FOR_SHIPING: {
    value: 20,
    label: '待结算',
  },
  BOOKING_DENIED: {
    value: 30,
    label: '已拒绝',
  },
  BOOKING_RECEIVING: {
    value: 45,
    label: '结算中',
  },
  BOOKING_FINISHED: {
    value: 50,
    label: '交易成功',
  },
  BOOKING_CANCELLED: {
    value: 60,
    label: '已取消',
  },
};

// 供应商订单状态
export const supplierTransactionOrderStatusEnum = {
  BOOKING: {
    value: 10,
    label: '编制中',
  },
  WAIT_SUPPLIER_CONFIRM: {
    value: 15,
    label: '待确认',
  },
  BOOKING_FOR_SHIPING: {
    value: 20,
    label: '待结算',
  },
  BOOKING_DENIED: {
    value: 30,
    label: '已拒绝',
  },
  BOOKING_RECEIVING: {
    value: 45,
    label: '结算中',
  },
  BOOKING_FINISHED: {
    value: 50,
    label: '交易成功',
  },
  BOOKING_CANCELLED: {
    value: 60,
    label: '已取消',
  },
};

// 子合同订单状态集合
export const genSubContractTradeOrderStatusLists = () => [
  SubcontractTradeOrderStatusEnum.BOOKING, // 编制中
  SubcontractTradeOrderStatusEnum.WAIT_SUPPLIER_CONFIRM, // 待确认
  SubcontractTradeOrderStatusEnum.BOOKING_FOR_SHIPING, // 待结算
  SubcontractTradeOrderStatusEnum.BOOKING_DENIED, // 已拒绝
  SubcontractTradeOrderStatusEnum.BOOKING_RECEIVING, // 结算中
  SubcontractTradeOrderStatusEnum.BOOKING_FINISHED, // 交易成功
  SubcontractTradeOrderStatusEnum.BOOKING_CANCELLED, // 已取消
];

// 供应商收货状态
export const SupplierReceivingStatusEnum = {
  TO_SETTLE: {
    value: 10,
    label: '已收货',
  },
  SETTLED: {
    value: 20,
    label: '已结算',
  },
  RETURN: {
    value: 30,
    label: '已退货',
  },
  INVALID: {
    value: 100,
    label: '已作废',
  },
};

// 商品价格显示方式
export const SKU_PRICE_SHOWWAY_ENUM = {
  ALL: {
    value: 1,
    label: '显示价格范围',
  },
  LOGIN: {
    value: 2,
    label: '显示最低价',
  },
};

export enum OrderFromEnum {
  TRADE_LIST,
  RECEIVING_LIST,
  DELIVER_LIST,
  PURCHASE_REQUEST_LIST,
}

// 到账日期天数
export const TermDaysEnum = {
  /**
   * 0天
   */
  ZERO_DAYS: { value: 0, label: '0天' },
  /**
   * 7天
   */
  SEVEN_DAYS: { value: 1, label: '7天' },
  /**
   * 1个月
   */
  ONE_MONTH: { value: 2, label: '1个月' },
  /**
   * 3个月
   */
  THREE_MONTH: { value: 3, label: '3个月' },

  /**
   * 6个月
   */
  SIX_MONTH: { value: 4, label: '6个月' },
  /**
   * 2个月
   */
  TWO_MONTH: { value: 5, label: '2个月' },
  /**
   * 其他
   */
  OTHER: { value: 6, label: '其他' },
  /**
   * 其他
   */
  INSTALLMENT: { value: 7, label: '分期付款' },
  /**
   * 4个月
   */
  FOUR_MONTH: { value: 8, label: '4个月' },

  /**
   * 4个月
   */
  FIVE_MONTH: { value: 9, label: '5个月' },
};

// 采购申请状态
export const PurchaseApplyStatusEnum = {
  SUBMITTED: {
    label: '已提交',
    value: 10,
  },
  DONE: {
    label: '已完成',
    value: 20,
  },
  DENIED: {
    label: '已拒绝',
    value: 30,
  },
  CANCELLED: {
    label: '已取消',
    value: 40,
  },
};

/**
 * 审批状态
 * 这是从服务端拿到的接口，写死了，后边可能要改造
 */
export const AuditStatusEnum = {
  NO_AUDIT: {
    value: 0,
    label: '无需审批',
  },
  AUDITING: {
    value: 1,
    label: '审批中',
  },
  FAIL: {
    value: 2,
    label: '审批未通过',
  },
  PASS: {
    value: 3,
    label: '审批通过',
  },
  CANCEL: {
    value: 4,
    label: '审批撤销',
  },
};

/*
 * 收货单审批和确认维度
 * @type {{SINGLE: {label: string, value: number}, BATCH: {label: string, value: number}}}
 */
export const ReceivingAuditAndConfirmDimensionEnum = {
  BATCH: {
    value: 1,
    label: '批量提交',
  },
  SINGLE: {
    value: 2,
    label: '单独提交',
  },
};

// 轨迹状态
export const HasWayBillTypeEnum = {
  EXIST: {
    value: 1,
    label: '有轨迹',
  },
  EXIST_PART: {
    value: 3,
    label: '有部分轨迹',
  },
  EXIST_ALL: {
    value: 4,
    label: '全部有轨迹',
  },
  NON_EXIST: {
    value: 2,
    label: '无',
  },
};

// 发货详情
export const DeliveryDetailEnum = {
  WAIT_CONFIRM: {
    value: 2,
    label: '待确认',
  },
  WAIT_OUTBOUND: {
    value: 5,
    label: '待出库',
  },
  WAIT_RECEIVE: {
    value: 10,
    label: '待收货',
  },
  RECEIVE_ING: {
    value: 15,
    label: '收货中',
  },
  ALREADY_RECEIVE: {
    value: 20,
    label: '已收货',
  },
  ALREADY_SETTLEMNT: {
    value: 30,
    label: '已结算',
  },
  ALREADY_RETURN: {
    value: 40,
    label: '已退货',
  },
  INVALID: {
    value: 50,
    label: '已作废',
  },
};

// 物流获取方式
export enum LogisticsGetWayEnum {
  FROM_LOGISTICS_APP = 1, // 司机安装严选物流APP获取
  FROM_THIRD_PARTY, // 车载定位（北斗系统）（需缴纳查询费用）
}

// 店铺页模块类型
export enum ShopPageType {
  PRODUCT_FLOOR = 1, // 商品楼层
  PRODUCT_LIST, // 商品列表
  GRAPHICS, // 图文介绍
  LINK, // 链接
  INTERNAL, // 内置页面
}

// 店铺页类型
export enum ShopPageType {
  INDEX = 1, // 首页
  PROFILE, // 企业档案
  NORMAL, // 普通页面
}

// 店铺类型
export enum ShopType {
  BASIC = 1, // 基础版
  PRO, // 高级版
}

// 租户公告类型
export enum BulletinTypeEnum {
  BOE = 1, // 票据公告（票据首页)
  PLATFORM, // 平台动态
  LAW_GJ, // 法律法规-国家政策法规
  LAW_JX, // 法律法规-江西省政策法规
  LAW_TRADE_RULE, // 法律法规-交易规则
  SERVICE_TIPS, // 服务中心-操作手册
  SERVICE_DOWNLOAD, // 服务中心-文档下载
  HOME_QUESTION, // 首页-常见问题
  SITE_MESSAGE, // 站内信提醒
  ALERT, // 弹窗提醒
}

/**
 * 发货单外部收货系统是否结束
 */
export enum EndedByThirdPartyEnum {
  PROCESS = 0, // 未结束
  END, // 已结束
}

/**
 * 页面打开方式
 */
export const OPEN_TYPE_ENUM = {
  BLANK: {
    value: 1,
    label: '新开页面',
  },
  TOP: {
    value: 2,
    label: '当前页面打开',
  },
};

// 门户模块配置类型
export const PORTAL_FURNISH_CONFIG_TYPE_ENUM = {
  DEFAULT: {
    value: 0,
    label: '默认页面',
  },
  PRODUCT_FLOOR: {
    value: 1,
    label: '自定义页面',
  },
  PRODUCT_LIST: {
    value: 2,
    label: '商品列表',
  },
  GRAPHICS: {
    value: 3,
    label: '图文介绍',
  },
  LINK: {
    value: 4,
    label: '链接',
  },
  GJZQ: {
    value: 5,
    label: '钢筋专区',
  },
  JJZQ: {
    value: 6,
    label: '竞价专区',
  },
};

// 导航网站状态
export const PORTAL_FURNISH_STATUS_ENUM = {
  DRAFT: {
    value: 0,
    label: '编制中',
  },
  PUBLISH: {
    value: 1,
    label: '已发布',
  },
  REMOVED: {
    value: 2,
    label: '已撤下',
  },
};

// 导航标签
export const PORTAL_FURNISH_TAG_ENUM = {
  NORMAL: {
    value: 0,
    label: '普通页面',
  },
  COMMON: {
    value: 1,
    label: '公共',
  },
  LOGIN: {
    value: 2,
    label: '登录页',
  },
  MALL_INDEX: {
    value: 3,
    label: '商城首页',
  },
};

export enum CUSTOM_PAGE_TAG {
  COMMON = 1, // 公共
  LOGIN = 2, // 登录页
  MALL_INDEX = 3, // 商城首页
}

// 门户子模块
export const PORTAL_FURNISH_SUBGROUP = {
  COMMON: {
    value: 1,
    label: '公共',
  },
  MALL: {
    value: 2,
    label: '商城',
  },
};

export enum SITE_MODE {
  SHOP = 0,
  SELF,
}

// 评价节点类型
export const EvaluationNodeTypeEnum = {
  ORDER_TRADE_DELIVERY: {
    value: 1,
    label: '发货单评价',
  },
  ORDER_TRADE_RETURN: {
    value: 2,
    label: '退货单评价',
  },
  ORDER_TRADE_SETTLEMENT: {
    value: 3,
    label: '结算单评价',
  },
  ORDER_TRADE_ORDER_REFUSED: {
    value: 4,
    label: '订单拒绝评价',
  },
  ORDER_TRADE_ORDER_COMPLETED: {
    value: 5,
    label: '订单完成评价',
  },
  ORDER_PAYMENT_PAY_COMPLETED: {
    value: 6,
    label: '支付单支付完成评价',
  },
  ORDER_TRADE_DELIVERY_TRANSPORT: {
    value: 7,
    label: '发货单包裹评价',
  },
  ORDER_TRADE_DELIVERY_SUPPLIER: {
    value: 8,
    label: '供应商评价发货单',
  },
  ORDER_TRADE_ORDER_COMPLETED_SUPPLIER: {
    value: 9,
    label: '供应商评价订单完成',
  },
  ORDER_PAYMENT_PAY_COMPLETED_SUPPLIER: {
    value: 10,
    label: '供应商评价支付单支付完成',
  },
};

// 收货方式
export enum RECEIVING_MODE {
  NORMAL = 1,
  EASY, // 快速收货
}

// 分类商品类型
export enum CategoryGoodsType {
  producerGoods = '1',
  officeGoods = '2',
}
// 货运方式
export const ShippingMethodEnum = {
  CAR: {
    value: 1,
    label: '货运',
  },
  EXPRESS: {
    value: 2,
    label: '快递',
  },
  SELF_PICK_UP: {
    value: 3,
    label: '自提',
  },
};

// 用户身份
export enum UserSource {
  inside = 2, //内部
  outside = 0, //外部
  personage = 4, //个人
}

export const ROLE_TYPE = {
  PURCHASER: 'purchaser',
  SUPPLIER: 'supplier',
  OPERATION: 'operation',
  PERSONAL: 'personal',
};

// 首页类型
export enum HomeType {
  old = '1',
  new = '2',
}

// 对外首页标识
export const HOME_SESSION_KEY = 'CURRENT_IS_NEW_HOME';

/**
 * 用户详情currentUserType对应的身份枚举
 */
export enum CurrentUserTypeSource {
  purchaser = 1,
  supplier = 2,
  personal = 32,
  operation = 64,
}

// 用户身份认证状态
export enum OrgAuditType {
  unAudit,
  supplier,
  purchaser,
  supplierAndPurchaser,
}

// 交易模式
export const tradeModeEnums = {
  SUPP: { value: 1, label: '供货模式' },
  SUBP: { value: 2, label: '专业分包模式' },
  LEASE: { value: 5, label: '租赁模式' },
};

export const NetPriceSource = {
  INFORMATION: {
    value: 1,
    label: '信息价',
  },
  LANGE: {
    value: 2,
    label: '兰格网网价',
  },
  WDGTW: {
    value: 3,
    label: '我的钢铁网网价',
  },
  BASE: {
    value: 4,
    label: '基础价',
  },
  NETWORK_SHYSJSW: {
    value: 5,
    label: '上海有色金属网网价',
  },
  BASE_PRICE: {
    value: 6,
    label: '固定协议价',
  },
};

// 创效审核状态
export const InnovationAuditStatusEnum = {
  REVIEWED: {
    label: '待审核',
    value: 999,
  },
  DONE: {
    label: '审核通过',
    value: 10,
  },
  DENIED: {
    label: '审核拒绝',
    value: 20,
  },
};

export const supplierSkuStatusEnum = {
  NEW: { value: -1, label: '新建' },
  SOLD_OUT: { value: 0, label: '已下架' },
  PUT_AWAY: { value: 1, label: '已上架' },
  ILLEGAL: { value: 2, label: '违规' },
};

/**
 * 创效额计算方式
 */
export const effectPriceEnum = {
  PurchaseNnitPrice: {
    value: 1,
    label: '未上商城前的采购价格单价(含税)',
    unit: '元',
    rule: '创效额=（未上商城前的采购价格单价-订单含税单价）*采购数量',
    subLabel: '历史采购单价',
  },
  ReductionRate: {
    value: 2,
    label: '对比未上商城前的采购价格(含税)，不扣除利息，降低率',
    unit: '%',
    rule: '创效额=[订单含税单价/（1-降低率）]*降低率*采购数量',
    subLabel: '降低率',
  },
  FloatDownward: {
    value: 3,
    label: '对比未上商城前的采购单价下浮金额(含税)',
    unit: '元',
    rule: '创效额=下浮金额*采购数量',
    subLabel: '下浮金额',
  },
  CompareWard: {
    value: 4,
    label: '对比浮动金额(含税)',
    unit: '元',
    rule: '创效额=（未上商城前相对基价的浮动值 -上商城后相对基价的浮动值）* 采购数量',
    subLabel: '下浮金额',
  },
};

export const TenderPersonTradeOrderStatusEnum = {
  ALL: {
    value: '',
    label: '全部',
    cls: '',
  },
  PAYING: {
    value: 5,
    label: '待支付',
    color: '#00BF83',
  },
  BOOKING_FOR_SHIPING: {
    value: 20,
    label: '待发货',
    cls: 'order-ship',
    color: '#5476FF',
  },
  BOOKING_SHIPING_DONE: {
    value: 40,
    label: '已发货',
    cls: 'order-ship-done',
    color: '#5476FF',
  },
  BOOKING_RECEIVING: {
    value: 45,
    label: '收货中',
    cls: 'order-ship-receiving',
    color: '#5476FF',
  },
  BOOKING_FINISHED: {
    value: 50,
    label: '交易成功', // 已完成
    cls: 'order-finish',
    color: '#00BF83',
  },
  NOTPAY: {
    value: 11,
    label: '待支付',
    color: '#00BF83',
  },
};

export const ORDER_SELF_CONFIRM_STATUS_ENUM = {
  NOT_CONFIRM: {
    value: 0,
    label: '无需确认',
  },
  WAIT_CONFIRM: {
    value: 1,
    label: '待自营确认',
  },
  CONFIRMED: {
    value: 2,
    label: '自营已确认',
  },
};
